<div>
  <button class="dialog-close-btn" aria-label="close dialog" mat-dialog-close>
    <img src="/icons/close-light-grey.svg" alt="" class="" width="20" />
  </button>
</div>
<mat-dialog-content class="mat-typography">
  @if (_data.state) {
  <div class="errorText">
    {{ 'common.quick_order_page_qty_validation_emea' | cxTranslate }}
  </div>
  } @else {
  <div class="errorText">
    {{ 'common.quick_order_page_qty_validation' | cxTranslate }}
  </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button class="btn btn-block button-launch" mat-dialog-close>Ok</button>
</mat-dialog-actions>